import { Experience } from "@portal/types/robot/IRobotEnums";

export const MapIndexToExperience = (selectedIndex: number) => {
  let result = Experience.None;
  if (selectedIndex === 1) result = Experience.Some;
  else if (selectedIndex === 2) result = Experience.Yes;
  return result;
};

export const MapExperienceToIndex = (experience: Experience | null): number | null => {
  if (experience === Experience.None) return 0;
  if (experience === Experience.Some) return 1;
  if (experience === Experience.Yes) return 2;
  return null;
};
